import axios from 'axios'
import config from '../config'
import {
    startLoading,
    endLoading
} from '../processing'
import {
    handleError
} from '../index'
import cookie from 'js-cookie'
axios.defaults.baseURL = config.baseURL

function authHeader() {
    return {
        'x-auth-token': cookie.get('token')
    }
}
export default {
    gameTrainStatistic: async (params) => {
        startLoading();
        try {
            const result = await axios.get(`/game/training/statistic`, {
                headers: authHeader(),
                params,
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentStatistic: async (params, isStation) => {
        startLoading();
        try {
            let Url = '/statistic/terminal/sales'
            if (isStation) {
                Url = '/statistic/station/increase'
            }
            const result = await axios.get(Url, {
                params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    managerRangeStatistic: async (params, type) => {
        startLoading();
        try {
            const mapType = {
                agent: '/statistic/agent/increase',
                sales: '/statistic/terminal/sales',
                stock: '/statistic/agent/stock',
                courseBuy: '/statistic/agent/course',
                courseRefund: '/statistic/agent/course',
                station: '/statistic/station/increase',
                lively: '/statistic/station/lively',
            }
            let Url = mapType[type]
            const result = await axios.get(Url, {
                params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    managerSalesStatistic: async (params) => {
        startLoading();
        try {
            const result = await axios.get(`/statistic/annual/cumulative/sales`, {
                headers: authHeader(),
                params,
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getStationListByCityId: async (params) => {
        startLoading();
        try {
            const result = await axios.get(`/station`, {
                headers: authHeader(),
                params,
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getStationSalesById: async (params) => {
        startLoading();
        try {
            const result = await axios.get(`/statistic/station/sales`, {
                headers: authHeader(),
                params,
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    gameTrainStatisticReplay: async (params) => {
        startLoading();
        try {
            const result = await axios.get(`/playback/training/analysis`, {
                headers: authHeader(),
                params,
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getExportSalesData: async (stationUUID, params) => {

        startLoading();
        try {
            const result = await axios.get(`/export/station/${stationUUID}/sales/performance`, {
                headers: authHeader(),
                responseType: "blob",
                params,
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    }

}


// WEBPACK FOOTER //
// ./src/http/componentsAPI/statistics.js